import React, { useEffect, useState } from 'react';
import { Box, Button, Snackbar, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import { ColorList } from '@/components/Interface';
import handHeart from '@/assets/images/hand_heart.png';
import { PharmacyOrder } from '@/types';

function MessageBox({ children }: { children: React.ReactNode }) {
  return (
    <Box
      bgcolor={ColorList.VERY_LIGHT_BLUE}
      borderRadius={12}
      p="12px"
      display="flex"
      alignItems="center"
    >
      <img
        src={handHeart}
        alt="message box"
        height={20}
        width={20}
        style={{ marginRight: 12 }}
      />
      <Typography>{children}</Typography>
    </Box>
  );
}

function Wrapper({ children }: { children: React.ReactNode }) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="end"
      bgcolor="white"
      p={2}
      style={{ gap: 12 }}
    >
      {children}
    </Box>
  );
}

interface Props {
  data: PharmacyOrder;
  updateOrder: () => void;
}

export function ButtonActions({ data, updateOrder }: Props) {
  const [error, setError] = useState<string | null>(null);
  const lebelIsNotReady =
    data.status === 'waiting_for_pickup' && !data.label_url;

  useEffect(() => {
    if (lebelIsNotReady) {
      setError('Label URL belum tersedia');
    }
  }, [lebelIsNotReady]);

  const openLabelInNewTab = (url?: string, message?: string) => {
    if (url) {
      window.open(url, '_blank');
    } else {
      setError(message ?? 'url not found');
    }
  };

  const handleAlertClose = () => {
    setError(null);
  };

  if (
    data.status === 'order_processed' ||
    (data.status === 'payment_successful' && data.pharmacy_code)
  ) {
    return (
      <Wrapper>
        <Button
          variant="outlined"
          color="primary"
          style={{ height: 48, borderRadius: 30, borderWidth: 2 }}
          onClick={() => {
            if (data.worksheet_url) {
              openLabelInNewTab(
                data.worksheet_url,
                'Worksheet URL tidak ditemukan'
              );
            } else {
              window.location.reload();
            }
          }}
        >
          {data.worksheet_url
            ? 'Cetak Worksheet'
            : 'Reload untuk mendapatkan Worksheet'}
        </Button>
        <Button
          variant="outlined"
          color="primary"
          style={{ height: 48, borderRadius: 30, borderWidth: 2 }}
          onClick={() => {
            if (data.invoice_url) {
              openLabelInNewTab(
                data.invoice_url,
                'Invoice URL tidak ditemukan'
              );
            } else {
              window.location.reload();
            }
          }}
        >
          {data.invoice_url
            ? 'Cetak Etiket'
            : 'Reload untuk mendapatkan Etiket'}
        </Button>
        <Button
          variant="contained"
          color="primary"
          style={{ height: 48, borderRadius: 30, boxShadow: 'none' }}
          onClick={updateOrder}
          disabled={data.disable_preparing}
        >
          Selesai Menyiapkan Obat
        </Button>
      </Wrapper>
    );
  }

  if (data.status === 'payment_successful' && !data.pharmacy_code) {
    return (
      <Wrapper>
        <Button
          variant="contained"
          color="primary"
          style={{ height: 48, borderRadius: 30, boxShadow: 'none' }}
          onClick={updateOrder}
        >
          Ambil Pesanan
        </Button>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <MessageBox>
        Terima kasih telah menyiapkan resep kami! <br />
        {data.is_self_pickup
          ? 'Harap klik tombol di bawah ketika pasien mengambil obat.'
          : 'Mohon tunggu hingga kurir menjemput paket resep ini.'}
      </MessageBox>

      {data.is_self_pickup ? (
        <Button
          variant="contained"
          color="primary"
          style={{ height: 48, borderRadius: 30, borderWidth: 2 }}
          onClick={updateOrder}
          disabled={data.status !== 'waiting_self_pickup'}
        >
          Obat Sudah Diambil
        </Button>
      ) : (
        <Button
          variant="outlined"
          color="primary"
          style={{ height: 48, borderRadius: 30, borderWidth: 2 }}
          onClick={() => {
            if (lebelIsNotReady) {
              window.location.reload();
              return;
            }
            openLabelInNewTab(data.label_url, 'Label URL tidak ditemukan');
          }}
        >
          {lebelIsNotReady
            ? 'Reload untuk mendapatkan Label Pengiriman'
            : 'Cetak Label Pengiriman'}
        </Button>
      )}

      <Snackbar
        open={error !== null}
        onClose={handleAlertClose}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleAlertClose} severity="error">
          {error}
        </Alert>
      </Snackbar>
    </Wrapper>
  );
}
